import shipvistaAPI from "../shipvistaAPI";

export const updateOrdersService = (storeId: number) =>
  shipvistaAPI.get(`/marketplaces/UpdateOrders?id=${storeId}`);
